export const COLORS: Record<string, string> = {
  RED: "244,67,54", // Red (Vibrant)
  PINK: "233,30,99", // Pink (Bright)
  PURPLE: "156,39,176", // Purple (Rich)
  BLUE: "33,150,243", // Blue (Vibrant)
  ORANGE: "255,87,34", // Orange (Bold)
  TEAL: "0,200,136", // Teal (Fresh)
  YELLOW: "255,193,7", // Yellow (Bright)
  CYAN: "0,230,212", // Cyan (Bright)
  GREEN: "76,175,80", // Green (Strong)
  LIGHT_PINK: "255,100,129", // Light Pink (Warm)
  DARK_BLUE: "13,71,161", // Dark Blue (Deep)
  B_YELLOW: "255,235,0", // Bright Yellow (Vibrant)
  MAGENTA: "219,19,206", // Magenta (Vivid)
  GREY: "96,125,139", // Blue Grey (Neutral)
  WHITE: "255,255,255", // White (Pure)
  B_GREEN: "100,255,0", // Bright Green
};
